import { ReactComponent as ImagePlaceholder } from '../assets/icons/image-placeholder.svg';
export const prepareImageUrl = (_src, pattern, image) => {
    if (!_src) return image || ImagePlaceholder;
    const src = typeof _src === 'object' ? _src.src : _src;
    return src.replace(/(\.jpg(?=[^.jpg]*$)|\.png(?=[^.png]*$)|\.gif(?=[^.gif]*$)|\.jpeg(?=[^.jpeg]*$))*$/, pattern);
};
